import { useState, useEffect } from "react";
import { getPasswordComplexity } from "./systemSettingsService";

export function PasswordComplexityUsage() {
    const [complexityRules, setComplexityRules] = useState({
        passwordLength: 6,
        passwordUpperCase: 0,
        passwordLowerCase: 0,
        passwordNumber: 0,
        passwordSpecialCharacter: 0,
    });

    useEffect(() => {
        const fetchComplexity = async () => {
            try {
                const response = await getPasswordComplexity();
                const settings = Array.isArray(response) ? response : response.data ?? [];

                const settingsMap = settings.reduce((acc, setting) => {
                    acc[setting.name] = parseInt(setting.value) || 0;
                    return acc;
                }, {});

                if (settingsMap['passwordLength'])           setComplexityRules(prev => ({ ...prev, passwordLength:           settingsMap['passwordLength']           }));
                if (settingsMap['passwordUpperCase'])        setComplexityRules(prev => ({ ...prev, passwordUpperCase:        settingsMap['passwordUpperCase']        }));
                if (settingsMap['passwordLowerCase'])        setComplexityRules(prev => ({ ...prev, passwordLowerCase:        settingsMap['passwordLowerCase']        }));
                if (settingsMap['passwordNumber'])           setComplexityRules(prev => ({ ...prev, passwordNumber:           settingsMap['passwordNumber']           }));
                if (settingsMap['passwordSpecialCharacter']) setComplexityRules(prev => ({ ...prev, passwordSpecialCharacter: settingsMap['passwordSpecialCharacter'] }));

            } catch (error) {
                console.error('Error fetching password complexity:', error);
            }
        };
        fetchComplexity();
    }, []);

    const validatePassword = (password) => {
        const errors = [];

        if (password.length < complexityRules.passwordLength)
            errors.push(`At least ${complexityRules.passwordLength} characters long`);

        if (complexityRules.passwordUpperCase > 0 && (password.match(/[A-Z]/g) || []).length < complexityRules.passwordUpperCase)
            errors.push(`At least ${complexityRules.passwordUpperCase} uppercase letter(s)`);

        if (complexityRules.passwordLowerCase > 0 && (password.match(/[a-z]/g) || []).length < complexityRules.passwordLowerCase)
            errors.push(`At least ${complexityRules.passwordLowerCase} lowercase letter(s)`);

        if (complexityRules.passwordNumber > 0 && (password.match(/[0-9]/g) || []).length < complexityRules.passwordNumber)
            errors.push(`At least ${complexityRules.passwordNumber} number(s)`);

        if (complexityRules.passwordSpecialCharacter > 0 && (password.match(/[!@#$%^&*]/g) || []).length < complexityRules.passwordSpecialCharacter)
            errors.push(`At least ${complexityRules.passwordSpecialCharacter} special character(s) (!@#$%^&*)`);

        return errors; // Empty array means password is valid
    };

    return { complexityRules, validatePassword };
}